import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { SettingsEditPage } from './settings-edit';

import { PersonAvatarModule } from '../../components/person-avatar/person-avatar.module';

@NgModule({
  declarations: [
    SettingsEditPage
  ],
  imports: [
    PersonAvatarModule,
    IonicPageModule.forChild(SettingsEditPage)
  ],
  exports: [
    SettingsEditPage
  ],
  entryComponents: [
    SettingsEditPage
  ]
})
export class SettingsEditModule {}



// WEBPACK FOOTER //
// ./src/pages/settings-edit/settings-edit.module.ts